import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';

const TIMING = '250ms ease-in-out';

@Component({
    selector: 'app-tab',
    template: `
        <div *ngIf="isActive" [class.tab-group__content-wrapper]="!noContentWrapper">
            <div #tabContent @slide class="tab-content" role="tabpanel">
                <ng-content></ng-content>
            </div>
        </div> 
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [trigger('slide', [state('void', style({ opacity: 0 })), transition(':enter', [animate(TIMING, style({ opacity: 1 }))])])],
})
export class TabComponent {
    @Input() label?: string;
    @Input() noContentWrapper = false;
    @Input() isActive = false;

    @ViewChild('tabContent') _tabContent: ElementRef<HTMLDivElement>;

    constructor(private cd: ChangeDetectorRef) {}

    setActive(active: boolean) {
        this.isActive = active;
        this.cd.markForCheck();
    }
}
